export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dramatic%20abstract%20composition%20with%20warm%20crimson%20and%20deep%20amber%20tones%2C%20soft%20gradient%20background%20with%20subtle%20texture%2C%20newspaper%20headline%20fragments%20floating%20artistically%2C%20modern%20editorial%20design%20atmosphere%2C%20sophisticated%20visual%20identity%2C%20no%20text%20visible%2C%20artistic%20abstract%20style&width=1920&height=900&seq=hero-bg-main&orientation=landscape"
          alt="吃瓜每日大赛 - 娱乐圈八卦与网红爆料聚合平台"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-[1280px] mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 mb-6">
              <span className="w-2 h-2 rounded-full bg-primary-400 animate-pulse"></span>
              <span className="text-xs font-medium text-primary-200 whitespace-nowrap">实时追踪 · 全网最快爆料</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white font-heading leading-tight mb-4">
              吃瓜每日大赛
              <br />
              <span className="text-primary-300">娱乐圈瓜与网红八卦第一现场</span>
            </h1>

            <p className="text-lg font-medium text-white/80 font-heading mb-6">
              一手黑料，每日更新，吃瓜快人一步
            </p>

            <div className="space-y-3 mb-8">
              <p className="text-sm md:text-base text-white/70 leading-relaxed max-w-lg mx-auto lg:mx-0">
                专注每日吃瓜最新爆料与今日黑料，覆盖娱乐圈瓜、网红八卦及最新吃瓜事件。
                7×24 小时实时追踪热门爆料动态，采编团队三班轮值，重大突发事件 30 分钟内上线。
                一手黑料吃瓜尽在此处，做最值得信赖的吃瓜第一站。
              </p>
              <p className="text-sm md:text-base text-white/70 leading-relaxed max-w-lg mx-auto lg:mx-0">
                当前热点：顶流恋情、综艺冲突、网红造假三大话题同时引爆，全网讨论量突破千万。
              </p>
            </div>

            <div className="flex items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8 flex-wrap">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-white font-heading">500万+</div>
                <div className="text-xs md:text-sm text-white/50 mt-1">月活跃用户</div>
              </div>
              <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-white font-heading">7×24h</div>
                <div className="text-xs md:text-sm text-white/50 mt-1">全天候追踪</div>
              </div>
              <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-white font-heading">30min</div>
                <div className="text-xs md:text-sm text-white/50 mt-1">突发事件响应</div>
              </div>
            </div>

            <div className="flex items-center justify-center lg:justify-start gap-3 flex-wrap">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-md text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                查看今日热点
              </a>
              <a
                href="#updates"
                className="inline-flex items-center gap-2 px-6 py-3 bg-white/10 hover:bg-white/20 text-white font-semibold rounded-md text-sm border border-white/30 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-timer-flash-line text-lg"></i>
                最新快讯
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-none hidden md:block">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-500/10 rounded-2xl blur-3xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=A%20dramatic%20artistic%20composition%20of%20a%20smartphone%20screen%20displaying%20glowing%20news%20headlines%20floating%20out%20of%20the%20device%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20modern%20editorial%20design%2C%20dark%20atmospheric%20background%2C%20cinematic%20lighting%2C%20no%20recognizable%20text%2C%20abstract%20tech-news%20aesthetic&width=900&height=700&seq=hero-visual-main&orientation=landscape"
                alt="吃瓜每日大赛平台界面展示"
                className="w-full h-auto rounded-xl relative z-10"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}